/** @jsxImportSource @emotion/react */
"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  containerStyles,
  slideStyles,
  contentWrapperStyles,
  contentStyles,
  textContainer,
  headingStyles,
  subheadingStyles,
  arrowButtonStyles,
  arrowLeftStyles,
  arrowRightStyles,
  ctaButtonStyles,
} from "./styles";

const images = ["/images/hero-banner-1.avif", "/images/hero-banner-2.avif"];

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const prev = () =>
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  const next = () => setCurrentSlide((prev) => (prev + 1) % images.length);

  return (
    <Box css={containerStyles}>
      {images.map((src, idx) => (
        <Box key={src} css={slideStyles(currentSlide === idx)}>
          <Image
            src={src}
            alt={`Slide ${idx + 1}`}
            fill
            priority={idx === 0}
            style={{ objectFit: "cover", objectPosition: "center" }}
            sizes="100vw"
          />
        </Box>
      ))}

      {/* Arrows */}
      <IconButton
        aria-label="prev arrow"
        onClick={prev}
        css={[arrowButtonStyles, arrowLeftStyles]}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <IconButton
        aria-label="next arrow"
        onClick={next}
        css={[arrowButtonStyles, arrowRightStyles]}
      >
        <KeyboardArrowRightIcon />
      </IconButton>

      <Box css={contentWrapperStyles} pr={8}>
        <Box css={contentStyles}>
          <Box css={textContainer}>
            <Typography
              variant="h1"
              component="h1"
              css={headingStyles}
              gutterBottom
            >
              Famento Design
            </Typography>
            <Typography variant="h2" component="h2" css={subheadingStyles}>
              Renkli ve özgün beton <br /> dekoratif ürünler
            </Typography>
            <Button variant="contained" href="/urunler" css={ctaButtonStyles}>
              Ürünleri Keşfet
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
